/** Shared customer-only restriction for scheduling navigation and scheduled-flight links. */
export const schedulingCustomerOnly = true;
